export default __webpack_public_path__ + "static/20230829-6db6673eb68dbe5913a311c9b106ff26.png";